// ScrollTo Element
//
// show and disappear the ScrollTo Button

import throttle from 'lodash/throttle';

class ScrollTop {
    constructor(elem) {
        this.elem = elem;
        this.amountScrolled = 250;
    }

    init() {
        $(window).on('scroll', throttle(() => {
            this.initScrollToTop();
        }));

        $(this.elem).find('.m-scroll-top__button').on('click', (e) => {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0
            }, 500);
        });
    }

    initScrollToTop() {
        const scrollPositionFromTop = $(window).scrollTop();
        const viewportBottomPosition = scrollPositionFromTop + $(window).height() - 10; // 10 is the spacing of the button from the bottom of the page
        const footerPositionFromTop = $('.js-footer').offset().top;

        // Set to fixed when footer is in view
        if(viewportBottomPosition > footerPositionFromTop) {
            $(this.elem).removeClass('m-scroll-top--fixed');
            return;
        }

        $(this.elem).addClass('m-scroll-top--fixed');

        // Set to visible when page is scrolled more then amountScrolled
        if(scrollPositionFromTop < this.amountScrolled ) {
            $(this.elem).removeClass('m-scroll-top--visible');

            return;
        }

        $(this.elem).addClass('m-scroll-top--visible');
    }
}

export default ScrollTop;
